import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import HomeV2 from '../views/HomeV2.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/chaldal',
    name: 'chaldal',
    component: () => import('../views/Chaldal.vue'),
  },
  {
    path: '/cmed',
    name: 'cmed',
    component: () => import('../views/Cmed.vue'),
  },
  {
    path: '/greeho',
    name: 'greeho',
    component: () => import('../views/JobPosts/greeho.vue'),
  },
  {
    path: '/shikho',
    name: 'shikho',
    component: () => import('../views/JobPosts/Shikho.vue'),
  },
  {
    path: '/shikho-golang',
    name: 'shikho-junior',
    component: () => import('../views/JobPosts/shikho_junior.vue'),
  },
  {
    path: '/dealone',
    name: 'dealone',
    component: () => import('../views/JobPosts/Dealone.vue'),
  },
  {
    path: '/cmedFinance',
    name: 'cmedFinance',
    component: () => import('../views/JobPosts/cmedFinance.vue'),
  },
  {
    path: '/lcp',
    name: 'lcp',
    component: () => import('../views/lcp.vue'),
  },
  {
    path: '/lcpAsessment',
    name: 'lcpAsessment',
    component: () => import('../views/JobPosts/LcpAsessment.vue'),
  },
  {
    path: '/frontend',
    name: 'frontend',
    component: () => import('../views/JobPosts/Telmax.vue'),
  },
  {
    path: '/magnitoAccount',
    name: 'magnitoAccount',
    component: () => import('../views/JobPosts/Magnito/MagnitoAccount.vue'),
  },
  {
    path: '/magnitoContent',
    name: 'magnitoContent',
    component: () => import('../views/JobPosts/Magnito/MagnitoContent.vue'),
  },
  {
    path: '/ipage',
    name: 'ipage',
    component: () => import('../views/JobPosts/ipage.vue'),
  },
  // {
  //   path: '/aventra',
  //   name: 'aventra',
  //   component: () => import('../views/JobPosts/Aventra/aventra.vue'),
  // },
  {
    path: '/aventraUxUI',
    name: 'aventraUxUI',
    component: () => import('../views/JobPosts/Aventra/aventraUxUI.vue'),
  },
  {
    path: '/aventraNetwork',
    name: 'aventraNetwork',
    component: () => import('../views/JobPosts/Aventra/aventraNetwork.vue'),
  },
  {
    path: '/aventraRedhat',
    name: 'aventraRedhat',
    component: () => import('../views/JobPosts/Aventra/aventraRedhat.vue'),
  },
  {
    path: '/aventraAndriod',
    name: 'aventraAndriod',
    component: () => import('../views/JobPosts/Aventra/aventraAndriod.vue'),
  },
  {
    path: '/trucklagbe',
    name: 'truckLagbe',
    component: () => import('../views/JobPosts/truckLagbe.vue'),
  },
  // {
  //   path: '/aventraIos',
  //   name: 'aventraIos',
  //   component: () =>
  //     import('../views/JobPosts/JobPosts/Aventra/aventraIos.vue'),
  // },
  {
    path: '/aventraLaravel',
    name: 'aventraLaravel',
    component: () => import('../views/JobPosts/Aventra/aventraLaravel.vue'),
  },
  {
    path: '/docspace',
    name: 'docspace',
    component: () => import('../views/DocSpace.vue'),
  },
  {
    path: '/pluto',
    name: 'pluto',
    component: () => import('../views/JobPosts/Pluto/pluto.vue'),
  },
  {
    path: '/bongo',
    name: 'bongo',
    component: () => import('../views/JobPosts/Bongo/Bongo.vue'),
  },

  {
    path: '/bongoProjectManager',
    name: 'bongoProjectManager',
    component: () => import('../views/JobPosts/Bongo/bongoProject.vue'),
  },
  {
    path: '/bongoMarketing',
    name: 'bongoMarketing',
    component: () => import('../views/JobPosts/Bongo/bongoMarketing.vue'),
  },
  {
    path: '/bongoProductOwner',
    name: 'bongoProductOwner',
    component: () => import('../views/JobPosts/Bongo/bongoProductOwner.vue'),
  },
  {
    path: '/ipageFlutter',
    name: 'ipageFlutter',
    component: () => import('../views/JobPosts/ipageFlutter.vue'),
  },
  {
    path: '/sheraDigital',
    name: 'sheraDigital',
    component: () => import('../views/JobPosts/SheraDigital.vue'),
  },

  {
    path: '/datascience',
    name: 'dataScience',
    component: () => import('../views/DataScience.vue'),
  },
  { path: '/im', name: 'im', component: () => import('../views/Im.vue') },
  {
    path: '/isa/im',
    name: 'im_isa',
    component: () => import('../views/Im.vue'),
  },
  {
    path: '/chaldal-terms',
    name: 'chaldal_terms',
    component: () => import('../views/ChaldalTerms.vue'),
  },
  {
    path: '/testing',
    name: 'testing',
    component: () => import('../views/HomeV2.vue'),
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: () => import('../views/Recruit.vue'),
  },
  {
    path: '/jobSeeker',
    name: 'jobSeeker',
    component: () => import('../views/JobSeeker.vue'),
  },
  {
    path: '/testing1',
    name: 'createLanding',
    component: () => import('../views/LandingCreation.vue'),
  },
  {
    path: '/landingall',
    name: 'allPages',
    component: () => import('../views/LandingPagesAll.vue'),
  },
  // {
  //   path: '/testing',
  //   name: 'home',
  //   component: Home,
  // },
  {
    path: '/',
    name: 'home',
    component: HomeV2,
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../components/core/UPasswordChange.vue'
      ),
  },
  {
    path: '/workshop',
    name: 'workshops',

    component: () => import('../views/Workshop.vue'),
  },

  {
    path: '/isa/terms',
    name: 'im_terms',

    component: () => import('../views/ChaldalTerms.vue'),
  },
  {
    path: '/workshop/:workshopId',
    name: 'workshop',
    props: true,
    component: () => import('../views/workshopdetailsTest.vue'),
  },
  {
    path: '/host_workshop',
    name: 'earn',
    component: () => import('../views/EarnWithUpskill.vue'),
  },
  {
    path: '/corporate_training',
    name: 'corporate',
    component: () => import('../views/CorporateTraining.vue'),
  },
  {
    path: '/nrb',
    name: 'nrb',
    component: () => import('../views/NRB.vue'),
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FAQ'),
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/Blog.vue'),
  },
  {
    path: '/blog/:blogId',
    name: 'blog details',
    props: true,
    component: () => import('../views/BlogDetails.vue'),
  },
  {
    path: '/forget_password',
    name: 'forget_password',
    props: true,
    component: () => import('../views/ForgetPass.vue'),
  },
  {
    path: '/certificate',
    name: 'certificate',

    component: () => import('../views/Certificate.vue'),
  },
  {
    path: '/consultant_booking',
    name: 'consultant booking',

    component: () => import('../views/ConsultantBooking.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/UserRegister.vue'),
  },
  {
    path: '/register/:type',
    name: 'type_register',
    component: () => import('../views/ConsultantRegister.vue'),
  },
  {
    path: '/premium',
    name: 'premium',
    redirect: { name: 'library' },
  },
  {
    path: '/invoice',
    name: 'invoice_alias',
    redirect: { name: 'invoice' },
  },
  {
    path: '/library',
    name: 'library',
    component: () => import('../views/PremiumVideo.vue'),
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/UserLogin2.vue'),
  },
  {
    path: '/signup',
    name: 'signUp',
    component: () => import('../views/SignUp.vue'),
  },
  {
    path: '/login/trainer',
    name: 'trainer_login',
    component: () => import('../views/TrainerLogin'),
  },
  {
    path: '/premium/invoice',
    name: 'invoice',
    component: () => import('../views/Invoice.vue'),
  },
  {
    path: '/videos',
    name: 'courses',
    component: () => import('../views/Courses.vue'),
  },
  {
    path: '/video/:id',
    name: 'lessons',
    component: () => import('../views/PageCourseVideo.vue'),
  },
  {
    path: '/lesson/:id',
    name: 'lessonsp',
    component: () => import('../views/PremiumPageCourseVideo.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/password_change',
    name: 'password_change',
    component: () => import('../views/UserPassword.vue'),
  },
  {
    path: '/classroom',
    name: 'classroom',
    component: () => import('../views/Classroom.vue'),
  },
  {
    path: '/profile',
    name: 'user_profile',
    component: () => import('../views/UserProfile.vue'),
  },
  {
    path: '/thanks',
    name: 'thanks',
    component: () => import('../views/Thank.vue'),
  },
  {
    path: '/contribute',
    name: 'contribute',
    component: () => import('../views/Contribute.vue'),
  },
  {
    path: '*',
    name: 'error',
    component: () => import('../views/Error404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
